export default {"src":"/_next/static/media/chart-line-.ea3d45c1.svg","height":36,"width":36};